import React, { useState } from "react";
import {
  ContentCopyRounded,
  IosShareOutlined,
  LinkRounded,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  Tooltip,
  useTheme,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { usePostHog } from "posthog-js/react";
import {
  OPEN_SHARE_MESSAGE_MENU,
  CLOSE_SHARE_MESSAGE_MENU,
  COPY_MESSAGE_LINK,
  COPY_MESSAGE_CONTENT,
} from "../../../../../utils/posthogEvents";

function ShareMessage({ message }) {
  const posthog = usePostHog();
  const { enqueueSnackbar } = useSnackbar();
  const { answer, query } = message;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    posthog.capture(OPEN_SHARE_MESSAGE_MENU);
  };

  const handleClose = () => {
    setAnchorEl(null);
    posthog.capture(CLOSE_SHARE_MESSAGE_MENU);
  };

  const handleCopyMessage = () => {
    handleCopy(answer["content_object"]["text"], "Copied message to clipboard");
    posthog.capture(COPY_MESSAGE_CONTENT);
  };

  const handleCopyMessageLink = () => {
    const url = generateShareUrl(query["message_id"]);
    handleCopy(url, "Copied message link to clipboard");
    posthog.capture(COPY_MESSAGE_LINK);
  };

  const generateShareUrl = (messageId) => {
    const url = new URL(window.location.href);

    // Set the messageId as a query parameter
    url.searchParams.set("messageId", messageId);

    return url.toString(); // Return the complete URL as a string
  };

  const handleCopy = (content, toastMessage) => {
    window.navigator.clipboard.writeText(content);
    enqueueSnackbar(toastMessage);
    handleClose();
  };

  return (
    <Box ml={1}>
      <Tooltip title="Share">
        <IconButton
          size="small"
          sx={{ color: theme.palette.action.active }}
          onClick={handleClick}>
          <IosShareOutlined fontSize="small" sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        autoFocus={false}
        disableAutoFocusItem
        slotProps={{ paper: { sx: { borderRadius: 2 } } }}>
        <MenuItem onClick={handleCopyMessageLink}>
          <ListItemIcon>
            <LinkRounded sx={{ fontSize: 18 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: "body2" }}>
            Copy Message Link
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={handleCopyMessage}>
          <ListItemIcon>
            <ContentCopyRounded sx={{ fontSize: 18 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: "body2" }}>
            Copy Message Content
          </ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default ShareMessage;
